import { Logger } from "index";
import { Endpoint, Http } from "Application/Helpers/BaseEndpoint";
import { PortalUsersModel } from "../../PortalUsers/PortalUsersModel";

class Request {
    public userId: string | null | undefined = null;
    public developmentId: string = "";
    public plots: UserPlotRequest[] = [];
}
class UserPlotRequest {
    public plotId: string = "";
    public userPlotId: string | null | undefined = null;
}

class Response {}

export class POSTUserPlotEndpoint extends Endpoint<Request, Response> {
    constructor() {
        super();
        this.verb(Http.Post);
        this.path("/api/userlot/saveuserplots");
    }

    public async HandleRequestAsync(model: PortalUsersModel): Promise<any> {
        let request = new Request();
        let userPlotRequest = new UserPlotRequest();
        request.plots = [userPlotRequest];
        userPlotRequest.plotId = model.plotId;
        userPlotRequest.userPlotId = model.userPlotId;
        request.developmentId = model.developmentId;
        request.userId = model.id?.toString();
        return request;
    }

    public async HandleResponseAsync(response: Response): Promise<any> {
        Logger.logInformation("Response", response);

        //Return your model
        return {};
    }
}
